const module = { name: 'discovery/fanClub/standalone.app', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as loadingBars } from 'swug-fdRequire-call:@fd-assets/core-styles/loadingBars';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { fd_url_manager as links } from 'require-core';



import { Fandango as Fandango } from 'require-core';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes } from 'require-global';

const { EventTypes } = Fandango_adobeLaunch_EventTypes;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_cookie as Fandango_cookie_deleteCookie_set_setCookie } from 'require-core';

const { deleteCookie, set: setCookie } = Fandango_cookie_deleteCookie_set_setCookie;


import { Fandango_xhr as xhr } from 'require-core';



import { default as getZip } from 'swug-fdRequire-call:desktop/global/getZip';



import { global_consts as global_consts_FanClubPlanTerms_QueryParams_CookieNames } from 'require-core';

const { FanClubPlanTerms: { ANNUAL, MONTHLY }, QueryParams, CookieNames } = global_consts_FanClubPlanTerms_QueryParams_CookieNames;


import { default as Fandango_triggerEvent_triggerAnalyticsEvent } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;


const Selectors = {
    MOVIE_TIMES_BTN: '#fanClub-movie-times',
    PLANS: '.js-fanClub-plan',
    PURCHASE_ERROR: '#fanClub-error',
    SELECT_PLAN_BTNS: '.js-fanClub-select-plan-btn',
    SNACKBAR: '#fanClub-snackbar',
    TAB_BAR: '.js-fanClub-standalone__tab-bar',
    TAB_BTNS: '.js-fanClub-tab-btn',
    TABS: '.js-fanClub-tab',
}


const Styles = {
    ACTIVE_TAB: 'fanClub-standalone__tab--active',
    FADE_IN: 'fanClub-standalone__snackbar--fade-in',
    FADE_OUT: 'fanClub-standalone__snackbar--fade-out',
    HIDE: 'hide',
}


const Actions = {
    EDIT_ITEM: 'edit-item',
    REMOVED_ITEM: 'removed-item',
    VERIFY_SIGN_IN: 'verify-signin',
}


const EVENT_DEBOUNCE_THRESHOLD_MS = 300


const cooldowns = new Set()
function triggerFanClubEvent(eventName, suppliedTags = {}) {
    if (cooldowns.has(eventName)) {
        return;
    }
    cooldowns.add(eventName);
    setTimeout(() => {
        cooldowns.delete(eventName);
    }, EVENT_DEBOUNCE_THRESHOLD_MS);
    const unimplementedTags = {
        loyaltyProgramName: '',
        offersWithPurchase: '',
    };
    triggerAnalyticsEvent(eventName, {
        ...unimplementedTags,
        ...suppliedTags,
    });
}
function run() {
    checkDependencies(module.name, debugLog);
    const { origin, pathname, search } = window.location;
    const params = new URLSearchParams(search);
    const cmp = params.get(QueryParams.CAMPAIGN);
    const planIdFromQuery = params.get(QueryParams.FAN_CLUB_PLAN_ID);
    const { FANCLUB_ANNUAL_CLICK, FANCLUB_CONTINUE_CLICK, FANCLUB_MONTHLY_CLICK, PAGE_VIEW } = EventTypes;
    const $selectPlanButtons = $(Selectors.SELECT_PLAN_BTNS);
    const oneCartCheckoutURL = cmp ? links.oneCartCheckout({}, { cmp }) : links.oneCartCheckout();
    if (planIdFromQuery && params.has(QueryParams.FAN_CLUB_ACTION, Actions.EDIT_ITEM)) {
        const planBtn = $(`${Selectors.SELECT_PLAN_BTNS}[data-plan*="\\"planId\\":\\"${planIdFromQuery}\\""]`);
        triggerFanClubEvent(PAGE_VIEW, {
            productDetails: planBtn ? planBtn.data('plan').displayName : '',
            productId: planIdFromQuery,
            productType: 'fanclub',
        });
    }
    const setButtonLoading = (currentEl, loading) => {
        if (loading) {
            loadingBars.start(currentEl);
        }
        else {
            loadingBars.stop(currentEl);
        }
        $selectPlanButtons.attr('disabled', loading);
    };
    $(Selectors.TAB_BTNS).on('click', (e) => {
        const tab = $(e.currentTarget).data('tab');
        const map = { [ANNUAL]: MONTHLY, [MONTHLY]: ANNUAL };
        const thisTabEl = $(`${Selectors.TABS}[data-tab=${tab}]`);
        const otherTabEl = $(`${Selectors.TABS}[data-tab=${map[tab]}]`);
        thisTabEl.addClass(Styles.ACTIVE_TAB).attr('aria-checked', true);
        otherTabEl.removeClass(Styles.ACTIVE_TAB).attr('aria-checked', false);
        $(`${Selectors.PLANS}[data-term=${ANNUAL}]`).toggleClass(Styles.HIDE, tab !== ANNUAL);
        $(`${Selectors.PLANS}[data-term=${MONTHLY}]`).toggleClass(Styles.HIDE, tab !== MONTHLY);
        $(Selectors.TAB_BAR).css('--active-index', tab === MONTHLY ? 1 : 0);
    });
    $selectPlanButtons.on('click', (e) => {
        const $btn = $(e.currentTarget);
        const [btnEl] = $btn;
        const { editing, plan } = $btn.data();
        const { account: { isHardLoggedIn, isLoggedIn } = {} } = Fandango;
        e.preventDefault();
        $(Selectors.PURCHASE_ERROR).addClass(Styles.HIDE);
        setButtonLoading(btnEl, true);
        const clickEventName = editing
            ? FANCLUB_CONTINUE_CLICK
            : (plan.term === ANNUAL ? FANCLUB_ANNUAL_CLICK : FANCLUB_MONTHLY_CLICK);
        triggerFanClubEvent(clickEventName, {
            productDetails: plan.displayName,
            productId: plan.planId,
            productType: 'fanclub',
        });
        if (editing) {
            setButtonLoading(btnEl, false);
            window.location.href = oneCartCheckoutURL;
        }
        else if (isHardLoggedIn) {
            xhr.ajax({ data: plan, method: 'POST', url: links.napiAddFanClubToCart() })
                .done((res) => {
                setButtonLoading(btnEl, false);
                deleteCookie(CookieNames.FOGLIA_CART_ID, { domain: '.fandango.co.uk', path: '/' });
                setCookie(CookieNames.RISK_METRICS_REFERENCE_ID, res.rmid);
                window.location.href = oneCartCheckoutURL;
            })
                .fail(() => {
                setButtonLoading(btnEl, false);
                $(Selectors.PURCHASE_ERROR).removeClass(Styles.HIDE);
            });
        }
        else {
            params.set(QueryParams.FAN_CLUB_ACTION, Actions.VERIFY_SIGN_IN);
            params.set(QueryParams.FAN_CLUB_PLAN_ID, plan.planId);
            window.location.href = links[isLoggedIn ? 'signIn' : 'joinNow']({}, { from: `${origin}${pathname}?${params}` })
                + links.basicModeParams();
        }
    });
    if (params.has(QueryParams.FAN_CLUB_ACTION, Actions.REMOVED_ITEM)) {
        const $snackbar = $(Selectors.SNACKBAR);
        $snackbar.removeClass(Styles.HIDE);
        $snackbar.addClass(Styles.FADE_IN);
        setTimeout(() => {
            $snackbar.removeClass(Styles.FADE_IN).addClass(Styles.FADE_OUT);
            $snackbar.one('animationend', () => $snackbar.addClass(Styles.HIDE));
        }, 3000);
    }
    getZip.init(Selectors.MOVIE_TIMES_BTN);
}
run();
export default module.exports;